<template>
  <div class="reports">
    <v-layout>
      <v-flex md12>
        <v-card tile>
          <v-card-title style="background-color: teal" class="white--text">
            <h1 class="display-1">Manifests Overview</h1>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Set up manifests display !-->
    <v-layout>
      <v-flex md3>
        <v-card tile>
          <v-card-text class="pa-0">
            <v-layout>
              <v-card color="gray" height="100%" tile>
                <v-card-title class="title">
                  <span color="secondary">{{
                    english
                      ? "Manifest Date Range"
                      : "Manifeste Par Plage De Date"
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <DatePicker />
                </v-card-text>
                <v-text-field
                  outline
                  :label="
                    english
                      ? 'Search Manifest Number'
                      : 'Recherche d\'un manifeste'
                  "
                  append-icon="search"
                  color="blue"
                  class="mt-4 pa-3"
                  @click:append="searchForManifest()"
                  :rules="[(v) => !!v || 'Manifest number is required']"
                  v-model="manifestToSearch"
                  v-if="displayScanned"
                >
                </v-text-field>

                <p v-if="searchFeedback && displayScanned" class="red--text">
                  {{ searchFeedback }}
                </p>

                <v-layout v-if="searchResult && displayScanned">
                  <v-flex md12>
                    <v-layout align-center justify-center>
                      <v-flex md6
                        ><v-btn
                          round
                          color="green"
                          class="white--text"
                          v-on:click="clearSearch()"
                          >Clear Search</v-btn
                        ></v-flex
                      >
                    </v-layout>
                    <v-layout class="mt-4">
                      <v-flex md12>
                        <v-card
                          v-for="(manifest, index) in searchResult"
                          :key="index"
                          style="border: 0.2em solid #4e84ae"
                          class="mb-2"
                          flat
                        >
                          <v-list two-line>
                            <v-list-tile v-on:click="getManifestPDF(manifest)">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  <v-layout color="primary">
                                    <v-flex class="text-md-left"
                                      >Manifest #
                                      {{ manifest.manifest_number }}</v-flex
                                    >
                                    <v-flex class="text-md-right">{{
                                      formatDate(manifest.manifest_date)
                                    }}</v-flex>
                                  </v-layout>
                                </v-list-tile-title>
                                <v-list-tile-sub-title
                                  :class="{
                                    'white--text darken-1':
                                      findManifest(manifest) >= 0,
                                  }"
                                >
                                  <v-layout>
                                    <v-flex class="text-md-left">{{
                                      manifest.custname
                                    }}</v-flex>
                                    <v-flex class="text-md-right"
                                      >{{ manifest.manifest_customer }}/{{
                                        manifest.manifest_location
                                      }}</v-flex
                                    >
                                  </v-layout>
                                  <v-layout>
                                    <v-flex class="text-md-left">{{
                                      manifest.plant
                                    }}</v-flex>
                                  </v-layout>
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-layout>
          </v-card-text>
          <v-card-title>
            <span class="title" color="secondary" v-if="displayExceptions"
              >List of Manifest Exceptions</span
            >
            <span class="title" color="secondary" v-if="displayMissingManifests"
              >List of Missing Manifests</span
            >
            <span class="title" color="secondary" v-if="displayScanned"
              >List of Scanned Manifests</span
            >
          </v-card-title>
          <v-card-text v-if="displayScanned" class="pt-0">
            <div class="text-md-center pb-2" v-if="getTotalPages > 0">
              <v-pagination
                v-model="page"
                :length="getTotalPages"
              ></v-pagination>
            </div>
            <v-list two-line>
              <div
                v-for="(scannedManifest, index) in getCurrentPage"
                :key="index"
              >
                <v-list-tile
                  ripple
                  v-on:click="getManifestPDF(scannedManifest, false)"
                  :class="{
                    activeManifest: findManifest(scannedManifest) >= 0,
                  }"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-layout color="primary">
                        <v-flex class="text-md-left"
                          >Manifest #
                          {{ scannedManifest.manifest_number }}</v-flex
                        >
                        <v-flex class="text-md-right">{{
                          formatDate(scannedManifest.manifest_date)
                        }}</v-flex>
                      </v-layout>
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      :class="{
                        'white--text darken-1':
                          findManifest(scannedManifest) >= 0,
                      }"
                    >
                      <v-layout>
                        <v-flex class="text-md-left">{{
                          scannedManifest.custname
                        }}</v-flex>
                        <v-flex class="text-md-right"
                          >{{ scannedManifest.manifest_customer }}/{{
                            scannedManifest.manifest_location
                          }}</v-flex
                        >
                      </v-layout>
                      <v-layout>
                        <v-flex class="text-md-left">{{
                          scannedManifest.plant
                        }}</v-flex>
                      </v-layout>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action> </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
              </div>
            </v-list>
            <div class="text-md-center pt-2" v-if="getTotalPages > 0">
              <v-pagination
                v-model="page"
                :length="getTotalPages"
              ></v-pagination>
            </div>
          </v-card-text>

          <v-card-text v-if="displayExceptions" class="pt-0">
            <div class="text-md-center pb-2" v-if="getTotalPages > 0">
              <v-pagination
                v-model="page"
                :length="getTotalPages"
              ></v-pagination>
            </div>
            <v-list>
              <div v-for="(manifest, index) in getCurrentPage" :key="index">
                <v-list-tile
                  ripple
                  v-on:click="getManifestPDF(manifest, false)"
                  :class="{ activeManifest: findManifest(manifest) >= 0 }"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span color="primary" class="pr-2"
                        >Exception ID # {{ manifest.manifest_ID }}</span
                      >
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      :class="{
                        'white--text darken-1': findManifest(manifest) >= 0,
                      }"
                    >
                      <span>{{ manifest.manifest_plant }}</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip
                      v-if="manifest.manifest_file.includes('mismatch')"
                      color="orange white--text"
                      small
                      >Mismatch</v-chip
                    >
                    <v-chip
                      v-else-if="manifest.manifest_file.includes('nonexistent')"
                      color="red white--text"
                      small
                      >Not Found</v-chip
                    >
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
              </div>
            </v-list>
            <div class="text-md-center pt-2" v-if="getTotalPages > 0">
              <v-pagination
                v-model="page"
                :length="getTotalPages"
              ></v-pagination>
            </div>
          </v-card-text>

          <v-card-text v-if="displayMissingManifests" class="pt-0">
            <div class="text-md-center pb-2" v-if="getTotalPages > 0">
              <v-pagination
                v-model="page"
                :length="getTotalPages"
              ></v-pagination>
            </div>
            <v-list two-line>
              <div
                v-for="(missingManifest, index) in getCurrentPage"
                :key="index"
              >
                <v-list-tile ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-layout color="primary">
                        <v-flex class="text-md-left"
                          >Manifest # {{ missingManifest.rte04_man }}</v-flex
                        >
                        <v-flex class="text-md-right">{{
                          simpleFormatDate(missingManifest.rte04_dte)
                        }}</v-flex>
                      </v-layout>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-layout>
                        <v-flex class="text-md-left">{{
                          missingManifest.custname
                        }}</v-flex>
                        <v-flex class="text-md-right"
                          >{{ missingManifest.rte04_cst }}/{{
                            missingManifest.rte04_loc
                          }}</v-flex
                        >
                      </v-layout>
                      <v-layout>
                        <v-flex class="text-md-left">{{
                          missingManifest.plant
                        }}</v-flex>
                      </v-layout>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action> </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
              </div>
            </v-list>
            <div class="text-md-center pt-2" v-if="getTotalPages > 0">
              <v-pagination
                v-model="page"
                :length="getTotalPages"
              ></v-pagination>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex md9 style="background-color: teal">
        <v-flex md12 class="headerTabs">
          <v-flex md4>
            <v-card
              color="secondary"
              class="white--text"
              :class="{ selectedView: displayScanned }"
              @click="setList('scannedManifestData')"
              height="100%"
              tile
            >
              <v-card-title class="title">
                <span>Scanned Manifests</span>
              </v-card-title>
              <v-card-text>
                <span class="display-1">{{ actualManifestCount }}</span>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md4>
            <v-card
              color="teal lighten-2"
              class="white--text"
              :class="{ selectedView: displayMissingManifests }"
              @click="setList('missingManifestData')"
              height="100%"
              tile
            >
              <v-card-title class="title">
                <span>Missing Manifests</span>
              </v-card-title>
              <v-card-text>
                <span class="display-1">
                  {{ missingManifestCount }}
                </span>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md4>
            <v-card
              color="secondary"
              class="white--text"
              :class="{ selectedView: displayExceptions }"
              @click="setList('exceptionManifestData')"
              height="100%"
              tile
            >
              <v-card-title class="title">
                <span>Exception Manifests</span>
              </v-card-title>
              <v-card-text>
                <span class="display-1"> {{ exceptionManifestCount }}</span>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex md12>
          <v-snackbar v-model="snackbar.show" bottom>
            <v-alert
              v-model="snackbar.show"
              :type="snackbar.color"
              :timeout="5000"
              >{{ snackbar.msg }}</v-alert
            >
          </v-snackbar>
        </v-flex>

        <v-flex md12>
          <v-tabs
            v-if="manifestTabs.length > 0"
            id="tabSection"
            v-model="tab"
            color="tertiary"
            active-class="v-tabs__item--active teal--text grey lighten-5"
            hide-slider
            show-arrows
            class="px-2 mt-2"
          >
            <v-tab
              v-for="(manifest, index) in manifestTabs"
              :key="index"
              :href="'#' + manifest.manifestData.manifest_file"
              class="white--text"
            >
              <span>{{
                manifest.manifestData.manifest_file.includes("_")
                  ? `Exception ID # ${manifest.manifestData.manifest_ID}`
                  : `Manifest #${manifest.manifestData.manifest_file}`
              }}</span>
              <v-chip
                v-if="manifest.manifestData.status"
                class="white--text"
                :color="
                  manifest.manifestData.status === 'new' ? 'blue' : 'orange'
                "
                small
                >{{ manifest.manifestData.status }}</v-chip
              >
              <v-icon
                class="ml-2"
                color="red"
                @click="removeManifestTab(manifest.manifestData)"
                >close</v-icon
              >
            </v-tab>

            <v-tabs-items>
              <v-tab-item
                v-for="(manifest, index) in manifestTabs"
                :key="index"
                :value="manifest.manifestData.manifest_file"
              >
                <v-card
                  class="mb-2 py-2"
                  tile
                  v-if="manifest.manifestData.manifest_available == 0"
                >
                  <v-card-title class="title py-0">
                    <span class="mr-2" color="primary"
                      >Manifest Info Found</span
                    >
                    <v-chip
                      v-if="
                        manifest.manifestData.manifest_file.includes('mismatch')
                      "
                      color="orange white--text"
                      small
                      >Mismatch</v-chip
                    >
                    <v-chip
                      v-else-if="
                        manifest.manifestData.manifest_file.includes(
                          'nonexistent'
                        )
                      "
                      color="red white--text"
                      small
                      >Not Found</v-chip
                    >
                  </v-card-title>
                  <v-card-text class="py-0">
                    <v-layout v-if="manifest.alert">
                      <v-flex>
                        <v-alert
                          class="text-md-center text-lg-center"
                          transition="scale-transition"
                          :value="manifest.alert.show"
                          :type="manifest.alert.color"
                        >
                          <span class="subheading">{{
                            manifest.alert.msg
                          }}</span>
                        </v-alert>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex class="px-2">
                        <v-text-field
                          label="Manifest Number"
                          v-model="manifest.manifestData.manifest_number"
                          color="info"
                          mask="##########"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="px-2">
                        <v-menu
                          v-model="manifest.manifestDatePicker"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              label="Manifest Date"
                              v-model="manifest.manifestData.manifest_date"
                              v-on="on"
                              color="info"
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            color="#138397"
                            v-model="manifest.manifestData.manifest_date"
                            @input="manifest.manifestDatePicker = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md3 class="px-2">
                        <v-text-field
                          label="Manifest Customer Number"
                          v-model="manifest.manifestData.manifest_customer"
                          color="info"
                          mask="#####"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 class="px-2">
                        <v-text-field
                          label="Manifest Location Number"
                          v-model="manifest.manifestData.manifest_location"
                          color="info"
                          mask="#####"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 class="px-2">
                        <v-text-field
                          label="Manifest Route Number"
                          v-model="manifest.manifestData.manifest_route_number"
                          color="info"
                          mask="####"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex class="px-2">
                        <v-checkbox
                          v-model="overrideResponse"
                          color="info"
                          label="Override Route Optix findings, submit manifest anyway."
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="py-0">
                    <v-layout class="px-3">
                      <v-spacer></v-spacer>
                      <v-flex
                        v-if="!manifest.manifestData.status"
                        class="text-md-right"
                      >
                        <v-btn
                          @click="
                            manifestAction(manifest.manifestData, 'delete')
                          "
                          color="red"
                          class="mr-5"
                          dark
                          >Delete</v-btn
                        >
                        <v-btn
                          @click="validateException(manifest.manifestData)"
                          color="#0097A7"
                          class="ml-5"
                          dark
                          >Submit</v-btn
                        >
                      </v-flex>
                      <v-flex
                        v-else-if="manifest.manifestData.status === 'new'"
                        class="text-md-right"
                      >
                        <v-btn
                          @click="
                            manifestAction(manifest.manifestData, 'delete')
                          "
                          color="red"
                          class="mr-5"
                          dark
                          >Delete</v-btn
                        >
                        <v-btn
                          @click="
                            manifestAction(manifest.manifestData, 'append')
                          "
                          color="green"
                          class="ml-5 mr-2"
                          dark
                          >Append</v-btn
                        >
                        <v-btn
                          @click="
                            manifestAction(manifest.manifestData, 'replace')
                          "
                          color="blue"
                          dark
                          >Replace</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
                <v-card tile>
                  <embed
                    :src="manifest.manifestPDF"
                    type="application/pdf"
                    :style="{
                      height: displayExceptions ? '179.5em' : '266.5em',
                    }"
                  />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "@/components/manager/DatePicker";

import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      manifestExpected: 0,
      manifestActual: 0,
      manifestException: 0,
      manifestExpectedCount: 0,
      manifestActualCount: 0,
      manifestExceptionCount: 0,
      manifestsByMonth: [],
      menu: false,
      tab: null,
      manifestTabs: [],
      displayScanned: true,
      displayExceptions: false,
      displayMissingManifests: false,
      overrideResponse: false,
      snackbar: { show: false, color: "info", msg: "" },
      limitPerPage: 50,
      page: 1,
      manifestToSearch: "",
      searchResult: null,
      searchFeedback: "",
    };
  },
  components: { DatePicker },
  computed: {
    ...mapState(["dateToManifest", "dateFromManifest", "english"]),
    ...mapGetters(["monthBefore"]),
    manifestDisplayScannedList() {
      return this.$store.state.actualManifestData;
    },
    manifestDisplayExceptionList() {
      return this.$store.state.exceptionManifestData;
    },
    manifestDisplayMissingList() {
      return this.$store.state.missingManifestData;
    },
    exceptionManifestCount() {
      if (typeof this.$store.state.exceptionManifestData[0] === "undefined") {
        return 0;
      } else {
        return this.$store.state.exceptionManifestData.length;
      }
    },
    actualManifestCount() {
      if (typeof this.$store.state.actualManifestData[0] === "undefined") {
        return 0;
      } else {
        return this.$store.state.actualManifestData.length;
      }
    },
    missingManifestCount() {
      if (typeof this.$store.state.missingManifestData[0] === "undefined") {
        return 0;
      } else {
        return this.$store.state.missingManifestData.length;
      }
    },
    getUserCountry() {
      return this.$store.state.userCountry;
    },
    getUserEntity() {
      return this.$store.state.entity;
    },
    getCurrentPage() {
      if (this.displayExceptions) {
        return this.manifestDisplayExceptionList.slice(
          (this.page - 1) * this.limitPerPage,
          this.page * this.limitPerPage
        );
      } else if (this.displayMissingManifests) {
        return this.manifestDisplayMissingList.slice(
          (this.page - 1) * this.limitPerPage,
          this.page * this.limitPerPage
        );
      } else if (this.displayScanned) {
        return this.manifestDisplayScannedList.slice(
          (this.page - 1) * this.limitPerPage,
          this.page * this.limitPerPage
        );
      }
    },
    getTotalPages() {
      if (this.displayExceptions) {
        return Math.ceil(
          this.manifestDisplayExceptionList.length / this.limitPerPage
        );
      } else if (this.displayMissingManifests) {
        return Math.ceil(
          this.manifestDisplayMissingList.length / this.limitPerPage
        );
      } else if (this.displayScanned) {
        return Math.ceil(
          this.manifestDisplayScannedList.length / this.limitPerPage
        );
      }
    },
  },

  methods: {
    setList(type) {
      if (type == "missingManifestData") {
        this.displayMissingManifests = true;
        this.displayExceptions = false;
        this.displayScanned = false;
      } else if (type == "exceptionManifestData") {
        this.displayExceptions = true;
        this.displayMissingManifests = false;
        this.displayScanned = false;
      } else if (type == "scannedManifestData") {
        this.displayScanned = true;
        this.displayExceptions = false;
        this.displayMissingManifests = false;
      }
    },
    // retrieveExpectedManifests() {
    // 	let baseURL = window.location.hostname;
    //
    // 	axios
    // 		.post("http://" + baseURL + "/manifests_api/expectedManifests", { date })
    // 		.then(async res => {
    // 			this.manifestExpected = res.data.filter(data => {
    // 				if (!data["RTE04_RTE"]) data["RTE04_RTE"] = "None";
    // 				return data["RTE04_RTE"];
    // 			});
    // 			this.manifestExpectedCount = this.manifestExpected.length;
    // 		})
    // 		.catch(err => {
    // 			console.log("Error", err);
    // 		});
    // },
    addManifestTab(manifestData) {
      return this.manifestTabs.push({
        manifestData: manifestData,
        manifestPDF: null,
      });
    },
    insertManifestTab(manifestData, manifestPDF) {
      let currentIndex = this.manifestTabs.findIndex((manifest) => {
        return (
          manifest.manifestData.manifest_number == manifestData.manifest_number
        );
      });

      if (currentIndex >= 0) {
        this.manifestTabs[currentIndex].manifestData.status = "new";
        this.manifestTabs[currentIndex].manifestData.oldManifestData =
          manifestData;
        // insert found manifest next to current manifest
        this.manifestTabs.splice(currentIndex + 1, 0, {
          manifestData: manifestData,
          manifestPDF: manifestPDF,
        });
        this.manifestTabs[currentIndex + 1].manifestData.status = "old";
        return currentIndex + 1;
      } else {
        return this.manifestTabs.length;
      }
    },
    removeManifestTab(manifestData) {
      let compareID = null;
      if (manifestData.oldManifestData) {
        compareID = manifestData.oldManifestData.manifest_ID;
      }

      this.manifestTabs = this.manifestTabs.filter((manifestTab) => {
        if (compareID == null) {
          return (
            manifestTab.manifestData.manifest_ID != manifestData.manifest_ID
          );
        } else {
          return (
            manifestTab.manifestData.manifest_ID != manifestData.manifest_ID &&
            manifestTab.manifestData.manifest_ID != compareID
          );
        }
      });
    },
    findManifest(manifestData) {
      return this.manifestTabs.findIndex((manifest) => {
        return manifest.manifestData.manifest_ID == manifestData.manifest_ID;
      });
    },
    getManifestPDF(manifestData, toCompare) {
      let found = this.findManifest(manifestData);

      if (found < 0) {
        manifestData.manifest_date = this.formatDate(
          manifestData.manifest_date
        ); // format date to show in form when selected
        if (manifestData.manifest_date === "Invalid date")
          manifestData.manifest_date = moment().format("YYYY-MM-DD");
        manifestData.alert = { show: false };
        manifestData.manifestDatePicker = false;
        let currIndex = this.manifestTabs.length;

        if (!toCompare) {
          currIndex = this.addManifestTab(manifestData) - 1;
        } else {
          currIndex = this.insertManifestTab(manifestData);
        }

        let requestData = manifestData;
        //console.log(requestData)

        let baseURL = window.location.hostname;
        let baseProtocol = window.location.protocol;
        axios
          .post(
            `${baseProtocol}//${baseURL}/manifests_api/getManifestPDF`,
            requestData,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            if (res.data) {
              const file = new Blob([res.data], { type: "application/pdf" });
              this.manifestTabs[currIndex].manifestPDF =
                URL.createObjectURL(file);

              if (!toCompare) {
                // switch tab only if it's not to compare
                this.tab = manifestData.manifest_file;
              }

              this.$vuetify.goTo("#tabSection", {
                duration: 1000,
                offset: 0,
                easing: "easeInQuad",
              });
            } else {
              console.log("No data found");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (found >= 0) {
        this.tab = this.manifestTabs[found].manifestData.manifest_file;
        this.$vuetify.goTo("#tabSection", {
          duration: 1000,
          offset: 0,
          easing: "easeInQuad",
        });
      }
    },
    validateException(manifestData) {
      let requestData = {
        country: this.getUserCountry,
        manifestData: manifestData,
        override: this.overrideResponse,
      };
      let manifestIndex = this.findManifest(manifestData);
      let manifestAlert = { ...this.snackbar }; // copy properties of the snackbar
      // send the user's input for the current manifest to see if the manifest already exists
      let baseURL = window.location.hostname;
      let baseProtocol = window.location.protocol;
      axios
        .post(
          `${baseProtocol}//${baseURL}/manifests_api/validateManifest`,
          requestData
        )
        .then((res) => {
          if (res.data) {
            // should send back if the manifest is already on file or not
            if (!res.data.exists) {
              // manifest was validated (no copy existed) and was saved successfully
              if (res.data.moved) {
                this.snackbar.color = "success";
                this.snackbar.msg = res.data.msg;
                this.snackbar.show = true;
                this.removeManifestTab(manifestData);
                this.$store.dispatch("LOAD_EXCEPTION_MANIFEST_DATA");
                this.overrideResponse = false;
              } else {
                // manifest was not moved due to a problem
                manifestAlert.color = "warning";
                manifestAlert.msg = res.data.msg;
                manifestAlert.show = true;
                this.$set(
                  this.manifestTabs[manifestIndex],
                  "alert",
                  manifestAlert
                );
              }
            } else if (res.data.exists) {
              // manifest was validated and a copy exists, need further user input
              manifestAlert.color = "info";
              manifestAlert.msg = res.data.msg;
              manifestAlert.show = true;
              this.$set(
                this.manifestTabs[manifestIndex],
                "alert",
                manifestAlert
              );
              this.getManifestPDF(res.data.manifestData, true);
            }
          } else {
            manifestAlert.color = "error";
            manifestAlert.msg = "Unable to unpack response from server.";
            manifestAlert.show = true;
            this.$set(this.manifestTabs[manifestIndex], "alert", manifestAlert);
          }
        })
        .catch((err) => {
          manifestAlert.color = "error";
          manifestAlert.msg =
            "Error occurred in response from server. Check console log.";
          manifestAlert.show = true;
          this.$set(this.manifestTabs[manifestIndex], "alert", manifestAlert);
          console.log(err.err);
        });
    },
    manifestAction(manifestData, actionSelected) {
      if (manifestData !== null) {
        let requestData = {
          country: this.getUserCountry,
          manifestData: manifestData,
          action: actionSelected,
        };
        let manifestIndex = this.findManifest(manifestData);
        let manifestAlert = { ...this.snackbar }; // copy properties of the snackbar
        // send the user's input for the current manifest to determine what is done with the manifest
        let baseURL = window.location.hostname;
        let baseProtocol = window.location.protocol;
        axios
          .post(
            `${baseProtocol}//${baseURL}/manifests_api/modifyManifest`,
            requestData
          )
          .then((res) => {
            if (res.data) {
              this.snackbar.color = "success";
              this.snackbar.msg = res.data.msg;
              this.snackbar.show = true;
              this.removeManifestTab(manifestData);
              this.$store.dispatch("LOAD_EXCEPTION_MANIFEST_DATA");
              this.overrideResponse = false;
            } else {
              manifestAlert.color = "error";
              manifestAlert.msg = "Unable to unpack response from server.";
              manifestAlert.show = true;
              this.$set(
                this.manifestTabs[manifestIndex],
                "alert",
                manifestAlert
              );
            }
          })
          .catch((err) => {
            manifestAlert.color = "error";
            manifestAlert.msg =
              "Error occurred in response from server. Check console log.";
            manifestAlert.show = true;
            this.$set(this.manifestTabs[manifestIndex], "alert", manifestAlert);
            console.log(err.err);
          });
      } else {
        this.snackbar.color = "error";
        this.snackbar.msg = "Error: manifest data not being passed to funtion.";
        this.snackbar.show = true;
      }
    },
    simpleFormatDate(manifest_date) {
      if (manifest_date) {
        return moment(manifest_date, "YYYYMMDD").format("YYYY-MM-DD");
      } else {
        return null;
      }
    },
    formatDate(manifest_date) {
      if (manifest_date) {
        return moment(manifest_date, "YYYY-MM-DD hh:mm:ss").format(
          "YYYY-MM-DD"
        );
      } else {
        return null;
      }
    },
    reverseFormatDate(manifest_date) {
      if (manifest_date) {
        return moment(manifest_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD hh:mm:ss"
        );
      } else {
        return null;
      }
    },
    searchForManifest() {
      const manifestNumber = this.manifestToSearch;

      const requestData = {
        country: this.getUserCountry,
        entity: this.getUserEntity,
        manifestNumber,
      };
      // console.log(requestData)

      let baseURL = window.location.hostname;
      let baseProtocol = window.location.protocol;
      axios
        .post(
          `${baseProtocol}//${baseURL}/manifests_api/searchManifestByEntity`,
          requestData
        )
        .then((res) => {
          if (res.data) {
            this.searchResult = res.data;

            if (typeof this.searchResult == "string") {
              this.searchFeedback = `No result found for ${manifestNumber}.`;
            } else {
              this.searchFeedback = "";
            }
          } else {
            console.log("No data found");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearSearch() {
      this.searchResult = null;
      this.manifestToSearch = null;
    },
  },
  mounted() {
    //this.retrieveActualManifests(this.date);
    //this.retrieveExpectedManifests(this.date);
  },
};
</script>

<style scoped>
.v-snack__content {
  padding: 0em;
}
.v-alert {
  width: 100%;
}
embed {
  width: 100%;
}
.selectedView {
  border: 0.2em solid #fff !important;
}
.maxHeight {
  max-height: 126px;
}
.headerTabs {
  display: flex;
}
</style>
